import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-sm leading-5 font-normal text-gray-800" }

import { ExclamationIcon } from "@heroicons/vue/outline"

interface Props {
    className?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsWarningBanner',
  props: {
    className: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.className, "rounded bg-gray-200 flex flex-row py-3 px-2 items-center gap-x-2"])
  }, [
    _createVNode(_unref(ExclamationIcon), { class: "text-gray-500 !w-6 !h-6" }),
    _createElementVNode("p", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})